import {
  IArticleWidgetProps,
  THeroBannerSlide,
  IPromoWidgetProps,
} from "../components";
import { articleWidgetData } from "./articleWidgetData";
import { promoDataActions, promoDataBase } from "./promoData";

const timesArr = Array.from(Array(5).keys());

const mockShorTitles = [
  "Adidas running",
  "winter sale",
  "SCOTT safety",
  "SALEWA response",
  "Active winter",
];

const PromoWidgetWideStory: IPromoWidgetProps = {
  ...promoDataBase,
  actions: [...promoDataActions],
  size: "wide",
  type: "default",
  mediaData: {
    data: {
      src: "assets/images/widget/promo-banner-wide.png",
    },
  },
};

const ArticleWidgetLargeStory: IArticleWidgetProps = {
  ...articleWidgetData,
  size: "large",
  type: "default",
};

function generateData(type: "promo" | "article" = "promo") {
  return timesArr
    .map((counter) => ({
      ...(type === "promo" ? PromoWidgetWideStory : ArticleWidgetLargeStory),
      id: String(counter),
      link: {
        href: `/some/url/${counter}`,
      },
    }))
    .map((banner) => ({
      ...banner,
      shortTitle:
        mockShorTitles[
          mockShorTitles.length -
            (Number(banner.id) % mockShorTitles.length) -
            1
        ],
      /*
      shortTitle: `${banner.title.slice(0, 8 + Number(banner.id) * 2)} ${
        banner.id
      }`,
      */
    }));
}

export const mockedHeroBannerPromoWidgetData: THeroBannerSlide[] =
  generateData("promo");
export const mockedHeroBannerArticleWidgetData: THeroBannerSlide[] =
  generateData("article");
